import React, { useMemo, useState } from "react";
import "./FAQ.css";

const FAQ = () => {
  const faqs = useMemo(
    () => [
      {
        q: "Trabalhei sem carteira assinada, ainda tenho direitos?",
        a: "Sim! Mesmo sem registro, é possível comprovar o vínculo com documentos, mensagens ou testemunhas. Um advogado ajuda a reunir provas e garantir que você receba o que é devido.",
      },
      {
        q: "Quanto tempo tenho para entrar com uma ação trabalhista?",
        a: "Você pode reclamar até 2 anos após o fim do contrato, podendo cobrar direitos dos últimos 5 anos.",
      },
      {
        q: "Posso processar mesmo se ainda estiver empregado?",
        a: "Sim. Se você sofre abusos, como atraso de salário, assédio ou falta de FGTS, pode entrar com ação mesmo ainda empregado.",
      },
    ],
    []
  );

  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (idx) => {
    setOpenIndex((prev) => (prev === idx ? -1 : idx));
  };

  return (
    <section className="faq" id="faq">
      <div className="faq-container">
        <div className="faq-header">
          <h2 className="faq-title">Perguntas Frequentes</h2>
          <p className="faq-subtitle">
            Respostas objetivas para dúvidas comuns em direitos trabalhistas.
          </p>
        </div>

        <div className="faq-card">
          <div className="faq-list" role="list">
            {faqs.map((item, idx) => {
              const isOpen = openIndex === idx;
              return (
                <div
                  key={item.q}
                  className={`faq-item ${isOpen ? "is-open" : ""}`}
                >
                  <button
                    type="button"
                    className="faq-question"
                    onClick={() => toggle(idx)}
                    aria-expanded={isOpen}
                  >
                    <span className="faq-question-text">{item.q}</span>
                    <span className="faq-icon" aria-hidden="true">
                      <span className="faq-icon-line" />
                      <span className="faq-icon-line faq-icon-line-2" />
                    </span>
                  </button>

                  <div
                    className="faq-answer-wrap"
                    style={{
                      maxHeight: isOpen ? "220px" : "0px",
                    }}
                  >
                    <div className="faq-answer">
                      <p>{item.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="faq-cta">
            <div className="faq-cta-text">
              <h3>Ainda tem dúvidas?</h3>
              <p>
                Cada situação trabalhista possui suas particularidades e merece
                uma análise cuidadosa. Entre em contato e receba uma orientação
                jurídica clara e personalizada para o seu caso.
              </p>
            </div>

            {/* Troque o href para seu WhatsApp / Link de contato */}
            <a
              className="faq-cta-btn"
              href="https://wa.me/5591981759284"
              target="_blank"
              rel="noreferrer"
            >
              Falar no WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
